<template>
    <v-row justify="space-between">
        <v-col cols="auto">
            <v-row class="ma-n4">
                <template v-for="item in modes">
                    <v-col cols="auto" class="pa-4" :key="item.value">
                        <v-btn
                            v-bind="{
                                value: item.value,
                                loading,

                                class: {
                                    ['min-w-120px min-w-lg-160px font-size-18']: true,
                                    ['font-weight-bold']: item.value == query.mode,
                                    ['font-weight-medium']: item.value != query.mode,
                                    ['primary']: item.value == query.mode,
                                    ['grey-f5']: item.value != query.mode,
                                },
                            }"
                            rounded
                            @click="(query.mode = item.value) && emit()"
                        >
                            {{ item.text }}
                        </v-btn>
                    </v-col>
                </template>
            </v-row>
        </v-col>
        <v-col cols="auto">
            <v-text-field v-model="query.searchValue" clearable placeholder="검색내용을 입력하세요." style="width: 327px" v-bind="{ ...attrs_input, loading }" @keydown.enter="emit" @click:clear="((query.searchValue = null) || true) && emit()">
                <template #prepend-inner>
                    <i class="icon icon-search-black mt-n8 mr-8"></i>
                </template>
            </v-text-field>
        </v-col>
    </v-row>
</template>

<script>
import { attrs_input } from "@/assets/variables";

const initQuery = (query = {}) => ({
    ...(query || {}),

    mode: query?.mode ?? "on-going",
    searchValue: query?.searchValue ?? null,
});

export default {
    props: {
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        attrs_input,
    }),
    computed: {
        modes() {
            return [
                {
                    text: "진행중",
                    value: "on-going",
                },
                {
                    text: "종료",
                    value: "finished",
                },
                {
                    text: "참여한 프로그램",
                    value: "on-board",
                    hides: !this.$store.state?.payload,
                },
            ].filter(({ hides }) => !hides);
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;
            if (query.mode == "on-going") delete query.mode;
            if (!query.searchValue) delete query.searchValue;

            this.$router.push({ query });
        },
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>